const getStyle = (el, ruleName) => getComputedStyle(el)[ruleName];

export default getStyle;
